import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';

const resizeObserverCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}:host{display:contents}";

const ResizeObserverUtility = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.slResize = createEvent(this, "sl-resize", 7);
    this.observedElements = [];
  }
  connectedCallback() {
    this.resizeObserver = new ResizeObserver((entries) => this.slResize.emit(entries));
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }
  handleSlotChange() {
    if (!this.element.shadowRoot)
      return;
    const slot = this.element.shadowRoot.querySelector('slot');
    if (!slot)
      return;
    const elements = slot.assignedElements({ flatten: true });
    // Unwatch previous elements
    this.observedElements.map((el) => this.resizeObserver.unobserve(el));
    this.observedElements = [];
    // Watch new elements
    elements.map((el) => {
      this.resizeObserver.observe(el);
      this.observedElements.push(el);
    });
  }
  render() {
    return h("slot", { onSlotchange: this.handleSlotChange });
  }
  get element() { return this; }
  static get style() { return resizeObserverCss; }
}, [1, "sl-resize-observer"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["sl-resize-observer"];
  components.forEach(tagName => { switch (tagName) {
    case "sl-resize-observer":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, ResizeObserverUtility);
      }
      break;
  } });
}

const SlResizeObserver = ResizeObserverUtility;
const defineCustomElement = defineCustomElement$1;

export { SlResizeObserver, defineCustomElement };
